import type { FaireProductEntity } from "../../entity_types/product";

export const p_2m7n8cysst: FaireProductEntity = {
  token: "p_2m7n8cysst",
  type: "product",
  name: "Marbled Cube Shaped Squishy Toy",
  brandToken: "b_837qgt5t4j",
  brandName: "Funteze",
  imageUrl:
    "https://cdn.faire.com/fastly/8772ca17b5d471565267c81f8fff3c6fc4f8317c3fd86477d48504fce61d2cea.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/10bafe1c584e8397351ee951175897acfcc9364a1f62c898f7e860e3be2d92a3.jpeg",
  ],
  priceDollars: 3.5,
  description:
    "Marbled Cube Shaped Squishy Toy\r\n\r\nStretchy Ice Cube Squeeze Toys for Boys Girls, Sensory Fidget Toys Stress Balls Anxiety Relief for Autism, Ideal Gifts, Ages\r\nSize- 2 Inch all around\r\n4 Colors Assorted",
  tags: [],
  msrpDollars: 7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:49.382Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
